import { WireFundsProcessingToolPanel } from "../WireFundsProcessingToolPanel";
import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWireFundsTable extends Layout {
    layoutWireFundsProcessingToolPanel: WireFundsProcessingToolPanel;
    sourceUnpostedWire: DataSource;
    tableWireFundsProcessing: Table;
}
